/* B-Brite Bright — storefront behaviour. No dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const R = (window.BB && window.BB.routes) || {};
  const T = (window.BB && window.BB.strings) || {};

  /* ---------- Reveal on scroll ---------- */
  const reveals = $$('.reveal');
  if (!reduceMotion && 'IntersectionObserver' in window && !document.body.classList.contains('no-anim')) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-in'));
  }

  /* ---------- Header search toggle ---------- */
  const searchToggle = $('[data-search-toggle]');
  const searchBar = $('[data-search-bar]');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', (e) => {
      e.preventDefault();
      searchBar.hidden = !searchBar.hidden;
      searchToggle.setAttribute('aria-expanded', String(!searchBar.hidden));
      if (!searchBar.hidden) $('input[type=search]', searchBar).focus();
    });
  }
  /* Close mobile nav on escape / link click */
  const mnav = $('[data-mobile-nav]');
  if (mnav) {
    mnav.addEventListener('click', (e) => { if (e.target.closest('a')) mnav.removeAttribute('open'); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && mnav.open) { mnav.removeAttribute('open'); $('summary', mnav).focus(); } });
  }

  /* ---------- Hero video: load after page, respect reduced motion, pause control ---------- */
  const hero = $('[data-hero]');
  if (hero) {
    const pauseBtn = $('[data-hero-pause]', hero);
    const pickVideo = () => {
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      return $(`[data-hero-video][data-bp="${mobile ? 'mobile' : 'desktop'}"]`, hero) || $('[data-hero-video]', hero);
    };
    const start = () => {
      if (reduceMotion) return;
      const v = pickVideo();
      if (!v || !v.dataset.src) return;
      v.src = v.dataset.src;
      v.muted = true;
      const p = v.play();
      if (p && p.then) {
        p.then(() => { v.classList.add('is-playing'); if (pauseBtn) pauseBtn.hidden = false; }).catch(() => { /* autoplay blocked: still image stays */ });
      }
      if (pauseBtn) {
        pauseBtn.addEventListener('click', () => {
          const paused = pauseBtn.getAttribute('aria-pressed') === 'true';
          if (paused) { v.play(); pauseBtn.setAttribute('aria-pressed', 'false'); pauseBtn.setAttribute('aria-label', pauseBtn.getAttribute('aria-label').replace(/^Play/, 'Pause')); }
          else { v.pause(); pauseBtn.setAttribute('aria-pressed', 'true'); pauseBtn.setAttribute('aria-label', 'Play background video'); }
        });
      }
    };
    if (document.readyState === 'complete') setTimeout(start, 300); else window.addEventListener('load', () => setTimeout(start, 300));
  }

  /* ---------- Showcase videos: click to load + play, one at a time ---------- */
  const allVideos = () => $$('video[data-showcase-video], .gallery__slide--video video');
  $$('[data-video-card]').forEach((card) => {
    const btn = $('[data-video-play]', card);
    const video = $('video', card);
    if (!btn || !video) return;
    btn.addEventListener('click', () => {
      const src = $('source[data-src]', video);
      if (src && !src.src) { src.src = src.dataset.src; video.load(); }
      card.classList.add('is-active');
      video.play().catch(() => {});
      video.focus();
    });
  });
  // gallery videos: lazy-attach src on first play attempt
  $$('.gallery__slide--video video').forEach((v) => {
    const s = $('source[data-src]', v);
    const attach = () => { if (s && !s.src) { s.src = s.dataset.src; v.load(); } };
    v.addEventListener('pointerdown', attach, { once: true });
    v.addEventListener('focus', attach, { once: true });
    v.addEventListener('play', attach, { once: true });
  });
  document.addEventListener('play', (e) => {
    if (e.target.tagName !== 'VIDEO' || e.target.hasAttribute('data-hero-video')) return;
    allVideos().forEach((v) => { if (v !== e.target && !v.paused) v.pause(); });
  }, true);

  /* ---------- Tabs (product finder) ---------- */
  $$('[data-tabs]').forEach((wrap) => {
    const tabs = $$('[role=tab]', wrap);
    const select = (tab) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        let n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') n = tabs[0];
        if (e.key === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); select(n); n.focus(); }
      });
    });
  });

  /* ---------- Variant pills keep price, stock, button and URL in sync ---------- */
  const syncVariant = (form, radio) => {
    const scope = form.closest('[data-product-card], [data-pdp]') || form;
    const available = radio.dataset.available === 'true';
    $$('[data-price-display]', scope).forEach((el) => { el.textContent = radio.dataset.price; });
    const stock = $('[data-stock]', scope);
    if (stock) {
      stock.textContent = available ? T.inStock : T.soldOut;
      stock.classList.toggle('is-in', available);
      stock.classList.toggle('is-out', !available);
    }
    $$('[data-add-button]', scope).forEach((b) => {
      b.disabled = !available;
      const l = $('[data-add-label]', b);
      if (l) l.textContent = available ? T.addToCart : T.soldOut;
    });
    const sv = $('[data-sticky-variant]', scope);
    if (sv && radio.dataset.title) sv.textContent = radio.dataset.title + ' · ';
    if (scope.matches('[data-pdp]')) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', radio.value);
      window.history.replaceState({}, '', url.toString());
      if (radio.dataset.media) {
        const slide = document.getElementById('Media-' + radio.dataset.media);
        if (slide) slide.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
      }
    }
  };
  document.addEventListener('change', (e) => {
    const r = e.target;
    if (r.matches('[data-product-form] input[type=radio][name=id]')) syncVariant(r.closest('form'), r);
  });

  /* Quantity steppers on PDP */
  $$('[data-step]').forEach((b) => b.addEventListener('click', () => {
    const input = b.parentElement.querySelector('input[type=number]');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.step, 10));
  }));

  /* ---------- Cart drawer ---------- */
  const drawer = $('[data-cart-drawer]');
  let lastFocus = null;
  const openDrawer = () => {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => { const p = $('.drawer__panel', drawer); if (p) p.focus(); }, 50);
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  };
  const renderDrawer = (html) => {
    if (!drawer || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-drawer] .drawer__panel');
    if (fresh) $('.drawer__panel', drawer).innerHTML = fresh.innerHTML;
  };
  const updateCount = (count) => {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  };
  const refreshCount = () => fetch((R.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => updateCount(c.item_count)).catch(() => {});

  if (drawer) {
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); }
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
      const q = e.target.closest('[data-qty-change]');
      if (q && drawer.contains(q)) {
        const line = q.closest('[data-line]');
        line.classList.add('is-loading');
        fetch(R.cartChange || '/cart/change', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: parseInt(line.dataset.line, 10), quantity: parseInt(q.dataset.qtyChange, 10), sections: 'cart-drawer' })
        }).then((r) => r.json()).then((d) => {
          if (d.sections) renderDrawer(d.sections['cart-drawer']);
          updateCount(d.item_count);
        }).catch(() => line.classList.remove('is-loading'));
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
      if (e.key === 'Tab' && drawer.classList.contains('is-open')) {
        const f = $$('a[href],button:not([disabled]),input,textarea,[tabindex]:not([tabindex="-1"])', $('.drawer__panel', drawer));
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
  }

  /* AJAX add to cart (falls back to normal form post without JS) */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form || !drawer) return;
    if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
    e.preventDefault();
    const fd = new FormData(form);
    if (!fd.get('id')) return;
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    const buttons = $$(`[data-add-button]`, form.closest('[data-pdp]') || form);
    if (e.submitter) buttons.push(e.submitter);
    buttons.forEach((b) => { b.setAttribute('aria-busy', 'true'); b.disabled = true; });
    const status = $('[data-form-status]', form);
    fetch(R.cartAdd || '/cart/add', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then((r) => r.json().then((d) => ({ ok: r.ok, d })))
      .then(({ ok, d }) => {
        if (!ok) throw new Error(d.description || d.message || T.error);
        if (d.sections) renderDrawer(d.sections['cart-drawer']);
        if (status) { status.textContent = T.added; status.classList.remove('is-error'); setTimeout(() => (status.textContent = ''), 4000); }
        refreshCount();
        openDrawer();
      })
      .catch((err) => { if (status) { status.textContent = err.message || T.error; status.classList.add('is-error'); } })
      .finally(() => buttons.forEach((b) => { b.removeAttribute('aria-busy'); b.disabled = false; }));
  });

  /* ---------- PDP gallery dots + sticky buy bar ---------- */
  $$('[data-gallery]').forEach((g) => {
    const track = $('[data-gallery-track]', g);
    const dots = $$('[data-gallery-go]', g);
    if (!track || !dots.length) return;
    dots.forEach((d) => d.addEventListener('click', () => {
      const i = parseInt(d.dataset.galleryGo, 10);
      track.scrollTo({ left: track.clientWidth * i + i * 12, behavior: reduceMotion ? 'auto' : 'smooth' });
    }));
    track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / (track.clientWidth + 12));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    }, { passive: true });
  });
  const pdp = $('[data-pdp]');
  const sticky = $('[data-sticky-buy]');
  if (pdp && sticky && 'IntersectionObserver' in window) {
    const target = $('.pdp__buy', pdp);
    const io = new IntersectionObserver(([e]) => {
      const show = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      $$('button', sticky).forEach((b) => (b.tabIndex = show ? 0 : -1));
      document.body.classList.toggle('has-sticky-buy', show);
    });
    if (target) io.observe(target);
  }
})();
